<template>
    <modal-wrapper modalClass="modal--form" :modalName="name" @before-open="beforeOpen">
        <div class="modal__header">
            <h1 v-if="template.id">{{$t('modals.edit_template.title')}}</h1>
            <h1 v-else>{{$t('modals.create_template.title')}}</h1>
        </div>

        <survey-template-form
            :template = "template"
            :wrapperClass="['modal__content']"
            @saved="onTemplateSaved">

            <div class="modal__footer" slot="buttons" slot-scope="{ isSaveDisabled }">
                <div class="actions">
                    <button class="actions__action--save pull-right" type="submit" :class="{disabled: isSaveDisabled}" :disabled="isSaveDisabled">{{$t('common.save')}}</button>
                    <button class="actions__action--cancel" type="button" @click="refetchAndClose">{{$t('modals.common.cancel')}}</button>
                </div>
            </div>
        </survey-template-form>
    </modal-wrapper>
</template>
<script>
    import Vue from 'vue';
    import { Component } from 'vue-property-decorator';
    import ModalWrapper from '@/components/general/ModalWrapper';

    import SurveyTemplateForm from '@/components/forms/survey-templates/SurveyTemplateForm';
    import { GET_SURVEY_TEMPLATE } from '@/store/modules/survey-template';

    @Component({
        components: {
            SurveyTemplateForm,
        }
    })
    export default class SurveyTemplateModal extends Vue {
        name = 'survey-template-modal';

        template = {};

        beforeOpen(event) {
            if (event.params && event.params.template) {
                this.template = event.params.template;
            }
        }

        onTemplateSaved(template) {
            this.$modal.hide(this.name);
            this.$router.push({ name: 'survey-template', params: { id: template.id }});
        }

        refetchAndClose() {
            if (this.template.id) {
                this.$store.dispatch(GET_SURVEY_TEMPLATE, {});
            }
            this.$modal.hide(this.name);
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/modals/survey-templates/SurveyTemplateModal.vue